const initialState = {
  newOrganizationContactForm: false,
  orgId: null,
  cntId: null,
  contactKey: null,
  honorific: null,
  firstName: null,
  lastName: null,
  suffix: null,
  title: null,
  workPhone: null,
  paroleOfficer: false,
  inactive: false,
  addressCity: null,
  createDate: null,
  editdate: null,
  contactEditedby: '',
  contactCreatedby: '',
};
export default initialState;
